import { render, staticRenderFns } from "./paneldynamic-prev-btn.vue?vue&type=template&id=12d79eb7&"
import script from "./paneldynamic-prev-btn.vue?vue&type=script&lang=ts&"
export * from "./paneldynamic-prev-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d79eb7')) {
      api.createRecord('12d79eb7', component.options)
    } else {
      api.reload('12d79eb7', component.options)
    }
    module.hot.accept("./paneldynamic-prev-btn.vue?vue&type=template&id=12d79eb7&", function () {
      api.rerender('12d79eb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/paneldynamic-actions/paneldynamic-prev-btn.vue"
export default component.exports